
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
  Inject,
  ElementRef,
  AfterViewInit,
  Renderer2,
  HostListener
} from '@angular/core';
import { MarketingService } from '../services/marketing.service';
import { Promotion } from '../models/marketing.model';
import { NgModel } from '@angular/forms';
import { CmsStudioService } from '../cms/cms-studio.service';
import { CmsViewDirectiveService } from '../cms/cmsdirectives/cmsviewdirective.service';
import { CmsViewDirectiveComponent } from '../cms/cmsdirectives/cmsviewdirective.component';
import { CommonService } from '../services';
import { NgProgressService } from '../services/ngProgress.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { HardwareDeviceReportModel, HardwareReadinessModel, WindowsFeatureModel, WorkFromAnywhereModel } from '../models/Windows11Readiness.model';
import { Windows11AssessmentService } from '../services/windows-11-assessment.service';


const LARGETOPWIDTH = "620%";
const UNSETTOPWIDTH = null;
@Component({
  selector: 'app-promotions',
  templateUrl: './windows-11-assessment.component.html',
  styleUrls: ['./windows-11-assessment.component.css'],
  providers: [CmsViewDirectiveComponent]
})
export class Windows11AssessmentComponent implements OnInit, OnDestroy {
  @ViewChild("ParentWrapper", { static: false }) parentWrapper: ElementRef;

  created = false;
  loadContent = false;
  toplevelWidth = LARGETOPWIDTH;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
  @ViewChild("fileUploadInput") fileUploadInput;
  columnData: string[] = [];
  targetColumn = 'UpgradeEligibility';
  parsedData: any[] = [];
  excludedHeaders: string[] = ['ManagedBy', 'Manufacturer', 'Model'];

  @ViewChild(BreadcrumbComponent, { static: true }) breadcrumbRef: BreadcrumbComponent;

  constructor(
    private activeRouter: ActivatedRoute,
    private marketingService: MarketingService,
    public ngProgress: NgProgressService,
    private router: Router,
    private windows11AssessmentService: Windows11AssessmentService,
    @Inject(CmsViewDirectiveService) private service,
    @Inject(ViewContainerRef) private viewContainerRef
  ) {
    this.toplevelWidth = this.router.url.includes("windows-11-report") ? LARGETOPWIDTH : UNSETTOPWIDTH;
  }

  ngOnInit() {
    this.loadContent = false;

    this.router.events.pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.ngUnsubscribe)).subscribe((res: NavigationEnd) => {
      if (this.router.url === '/windows-11-readiness') {
        $('.child-loader').animate({ scrollLeft: -$('#win-11-report').width() }, 980);
        this.breadcrumbRef.ngAfterViewInit();
      }
      this.toplevelWidth = res.url.includes("windows-11-report") ? LARGETOPWIDTH : UNSETTOPWIDTH;
    });
  }
  browseIntuneFile() {
    this.fileUploadInput.nativeElement.value = ''; 
    this.fileUploadInput.nativeElement.click();
  }

  onSelectFiles(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      const csvContent = reader.result as string;
      this.parseCsvAutoDetect(csvContent, ["ManagedBy", "Manufacturer", "Model"]);
    };

    reader.readAsText(file);
  }

  private parseCsvAutoDetect(csvContent: string, excludeHeaders: string[] = []): void {
    const lines = csvContent.split('\n').filter(line => line.trim() !== '');
    const rawHeaders = this.safeSplit(lines[0]);
    const headers = rawHeaders.filter(header => !excludeHeaders.includes(header.trim()));
    this.windows11AssessmentService.setAllDevicesUpgradedToWin11(false);
    const headerSet = new Set(rawHeaders.map(h => h.trim()));
    if (headerSet.has('ReadinessStatus') && headerSet.has('AppIssuesCount')) {
      const result = this.mapToModel<WindowsFeatureModel>(lines, rawHeaders, headers);
      this.windows11AssessmentService.SetWindowsFeatureData(result);
      this.windows11AssessmentService.setWin11ModelType('windowsFeature');
    } else if (headerSet.has('ManagedBy') && headerSet.has('UpgradeEligibility')) {
      const result = this.mapToModel<WorkFromAnywhereModel>(lines, rawHeaders, headers);
      this.windows11AssessmentService.setWorkAnywhereData(result);
      this.windows11AssessmentService.setWin11ModelType('workFromAnywhere');
    } else if (headerSet.has('Result') && headerSet.size <= 3) {
      const result = this.mapToModel<HardwareDeviceReportModel>(lines, rawHeaders, headers);
      this.windows11AssessmentService.setHardwareReadinessData(result);
      this.windows11AssessmentService.setWin11ModelType('hardwareReadiness');
    } else {
      throw new Error('Unknown CSV format');
      return;
    }

    this.router.navigate(['windows-11-readiness/windows-11-report']);
  }

  private mapToModel<T>(
    lines: string[],
    rawHeaders: string[],
    headers: string[]
  ): T[] {
    const trimmedHeaders = headers.map(header => header.trim());
    const trimmedRawHeaders = rawHeaders.map(header => header.trim());

    return lines.slice(1).map(line => {
      const values = this.safeSplit(line);
      const entry: any = {};

      // Map each header to its corresponding value
      trimmedHeaders.forEach(header => {
        const idx = trimmedRawHeaders.indexOf(header);
        if (idx !== -1) {
          entry[header] = values[idx]?.replace(/\r/g, '').trim(); // Trim values
        }
      });

      return entry as T;
    });
  }

  private safeSplit(line: string): string[] {
    const result: string[] = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"' && line[i + 1] === '"') {
        current += '"'; i++;
      } else if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        result.push(current); current = '';
      } else {
        current += char;
      }
    }
    result.push(current);
    return result;
  }

  ngOnDestroy(): void {
    // this.closesub$.unsubscribe();
  }

  goToDetails(): void {
    const link = document.createElement('a');
    //link.href = 'https://www.dickerdata.com.au/hubfs/windows-11/AUS-DDA-750-HowToPDF.pdf';  // relative to `assets` folder
    window.open('https://www.dickerdata.com.au/hubfs/windows-11/AUS-DDA-750-HowToPDF.pdf', '_blank');
    link.download = 'HowTo.pdf'; // the filename user will see
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (this.breadcrumbRef) {
      this.breadcrumbRef.ngAfterViewInit();
    }
  }

  close() {
    this.router.navigateByUrl('/');
  }

  onLoading(currentLoadingStatus: boolean) {
    this.ngProgress.done();
    console.log("currentLoadingStatus", currentLoadingStatus);
    this.loadContent = !currentLoadingStatus;
    console.log("loadContent", this.loadContent);
  }
  onNavigate(id, url) {
    this.marketingService.UpdatePromotionListAnalytics(id, this.windows11AssessmentService.analyticsClick).subscribe(value => {
      this.ngProgress.done();
      //success or error
    });
    window.open(url, '_blank');
  }
}